import React from 'react';
import { GeneralDialogProps, GeneralDialogShared } from '@shared/components/GeneralDialogShared/GeneralDialogShared';

const GeneralDialog = (props: GeneralDialogProps) => {
	return <GeneralDialogShared {...props} />;
};

export { GeneralDialog };
